import React from 'react';
import Berichtencentrum from '../../components/berichtencentrum/Berichtencentrum';

const PageBerichtencentrum: React.FC = () => {

  return (
    <>
      <header className="app-header">
        <h1>Berichtencentrum</h1>
        <p className="header-sub-title center">
          Overzicht van alle berichten voor uw organisatie. Als u een bericht op gelezen of ongelezen zet, geldt dat voor uw hele organisatie.<br/>
          Berichten worden 6 maanden bewaard, daarna worden ze automatisch verwijderd.
        </p>
      </header>

      <div className="content">
        <Berichtencentrum />
      </div>
    </>
  );
};

export default PageBerichtencentrum;
